import {default as confetti} from 'canvas-confetti';
import ProductBase from './ProductBase';
import Label from '../Partials/Label';
import Counter from './Counter';
import ImageOverlay from '../Partials/ImageOverlay';
import FavoriteButton from '../Partials/FavoriteButton';

const axios = require('axios');

export default {
  components: {FavoriteButton, ImageOverlay, Label},
  mixins: [ProductBase, Counter],

  props: {
    enableAutobid: {
      type: Boolean,
      required: false,
      default: true,
    },
  },

  emits: ['bid', 'isEnding', 'almostEnding', 'isEnding', 'ended', 'hasWon'],

  data () {
    const nextMinimalBid = this.nextBidAmount();
    return {
      currentBid: nextMinimalBid,
      nextMinimalBid,
      autoBid: Object.hasOwnProperty.call(this.item.auto_bid, 'auto_bid') ? this.item.auto_bid.auto_bid : null,
      timeLeft: this.counter(new Date(this.item.auction_ends_at)),
      hasWon: false,
      closingTime: this.getClosingTime(),
      counterInterval: null,
    };
  },

  computed: {
    timeLeftToText() {
      let hours = this.timeLeft.hours;
      if (this.timeLeft.days > 0) {
        hours += (this.timeLeft.days * 24);
      }

      return `${hours} uur, ${this.timeLeft.minutes} min en ${this.timeLeft.seconds} sec`;
    },
  },

  mounted () {
    this.updateTimer(false);
    this.calculateHasWon();
    this.counterInterval = setInterval(this.updateTimer, 1000);

    this.$echo.channel('auctions')
      .listen('AuctionUpdated', this.handleAuctionUpdatedEvent);
    this.$eventHub.$on('auctions.handlers', this.eventHandlers);
  },

  destroyed () {
    clearInterval(this.counterInterval);
    this.$echo.leaveChannel('auctions');
    this.$eventHub.$off('auctions.handlers', this.eventHandlers);
  },

  methods: {
    getFavoriteRoute() {
      return this.route('frontend.api.favorite.auction');
    },

    isOwn(customer_id) {
      return this.$page.props.customer.id === customer_id;
    },

    handleAuctionUpdatedEvent(event) {
      if (event.auction.id !== this.item.id) {
        return;
      }

      if (event.auction.bids) {
        this.$set(this.item, 'bids', event.auction.bids);
      }
      if (event.auction.customer_id) {
        this.$set(this.item, 'customer_id', event.auction.customer_id);
      }

      let hasEnded = false;
      if (this.item.ending_handled === false && event.auction.ending_handled === true) {
        hasEnded = true;
      }

      this.$set(this.item, 'is_ending', event.auction.is_ending);
      this.$set(this.item, 'ending_handled', event.auction.ending_handled);
      this.$set(this.item, 'auction_ends_at', event.auction.auction_ends_at);
      this.currentBid = this.nextBidAmount();
      this.closingTime = this.getClosingTime();
      this.checkAutoBid();
      this.calculateHasWon();

      if (hasEnded) {
        this.$nextTick(() => this.auctionEnded());
      }

      if (this.auctionUpdatedEventCallback) {
        this.auctionUpdatedEventCallback(this.item);
      }

      this.$forceUpdate();

      // this.$inertia.reload({ only: ['auctions'], preserveScroll: true });
    },

    eventHandlers (event, auctionId, ...args) {
      if (auctionId !== this.item.id) {
        return;
      }

      if (event === 'autobid') {
        this.autoBid = args[0];
      } else if (event === 'favorite') {
        this.item.favorite = true;
      }
    },

    bidOnAuction () {
      this.$eventHub.$emit(
        'bid',
        this.item,
        this.currentBid && this.currentBid.toString().includes('.')
          ? parseFloat(this.currentBid) : parseInt(this.currentBid),
      );
    },

    checkAutoBid() {
      if (
        this.autoBid
        && this.item.bids.data.length
        && parseFloat(this.item.bids.data[0].amount) >= parseFloat(this.autoBid)
      ) {
        this.autoBid = null;
      }
    },

    deleteAutoBid() {
      axios.post('/ajax/delete-autobod', {auction_id: this.item.id}).then(() => {
        this.autoBid = null;
        this.$eventHub.$emit('notification', 'success', 'Uw autobod is verwijderd!');
      });
    },

    getClosingTime() {
      let closingTime = null;
      const auctionEndsAt = new Date(this.item.auction_ends_at);

      if (this.item.ending_handled) {
        closingTime = `Gesloten om ${this.formatDateDigit(auctionEndsAt.getHours())}:${this.formatDateDigit(auctionEndsAt.getMinutes())}`;
      } else if (auctionEndsAt.getDay() === new Date().getDay()) {
        closingTime = `Sluit vandaag om ${this.formatDateDigit(auctionEndsAt.getHours())}:${this.formatDateDigit(auctionEndsAt.getMinutes())}`;
      } else {
        const date = auctionEndsAt.toISOString().split('T')[0];

        closingTime = `Sluit op ${date} om ${this.formatDateDigit(auctionEndsAt.getHours())}:${this.formatDateDigit(auctionEndsAt.getMinutes())}`;
      }

      return closingTime;
    },

    nextBidAmount () {
      if (this.item.bids.data.length) {
        return this.item.bids.data[0].amount + this.item.minimal_raise;
      }

      return this.item.starting_price;
    },

    updateTimer (dispatchEvents = true) {
      this.timeLeft = this.counter(new Date(this.item.auction_ends_at));

      if (
        dispatchEvents && this.timeLeft.minutes === 0
        && this.timeLeft.seconds > 10 && this.timeLeft.seconds < 60
      ) {
        this.$emit('almostEnding');
      }

      if (
        dispatchEvents && this.timeLeft.minutes === 0
        && this.timeLeft.seconds > 1 && this.timeLeft.seconds < 10
      ) {
        this.$emit('isEnding');
      }

      if (this.timeLeft.seconds < 0) {
        this.item.is_ending = true;
      }
    },

    raiseLow () {
      this.currentBid = parseInt(this.currentBid) + this.item.bidding_raise_low;
    },

    raiseHigh () {
      this.currentBid = parseInt(this.currentBid) + this.item.bidding_raise_high;
    },

    calculateHasWon () {
      this.hasWon = this.item.ending_handled === true
        && this.item.customer_id
        && this.isOwn(this.item.customer_id);
    },

    auctionEnded() {
      if (!this.hasWon) {
        this.$emit('ended');
        return;
      }

      const end = Date.now() + 1000;
      const colors = ['#1390CF', '#00BB00', '#FF0000', '#FD681B'];

      this.$emit('hasWon');

      (function frame() {
        confetti({
          particleCount: 10,
          angle: 60,
          spread: 55,
          origin: { x: 0 },
          colors,
        });
        confetti({
          particleCount: 10,
          angle: 120,
          spread: 55,
          origin: { x: 1 },
          colors,
        });

        if (Date.now() < end) {
          requestAnimationFrame(frame);
        }
      }());

      axios.post('/ajax/log/auction-won', {customer_id: this.$page.props.customer.id, auction_id: this.item.id});
    },
  },
};
